(function ($, Drupal, once) {

  /**
   * Fixes menu in Product Specifications page.
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.searchResultTopMenu = {
    attach: function attach(context) {
      const shareBlock = '#block-shareresultscontentblock';
      const printBlock = '#block-printblockonsearch';
      const downloadBlock = '#block-productcatalog';
      const searchBlock = '#block-jnjethicon-eprc-search-block';
      const changeLocation = '#block-epcchangelocation';

      let $download = $(downloadBlock, context).detach();
      let $share = $(shareBlock, context).detach();
      let $print = $(printBlock, context).detach();
      let $change = $(changeLocation, context).detach();
      let widthButtons = 'col-md-8';

      let divSharePrint = $('<div/>', { class: 'share-print' }).append($share, $print);
      let divGreyButtons = $('<div/>', { class: 'col-md-8 group-buttons' }).append($change, divSharePrint);
      let divRow = $("<div/>", { class: 'row' }).append($download, divGreyButtons);
      let divCol = $("<div/>", { class: 'col-md-6 hidden-print epc-highlighted-buttons' }).append(divRow);      

      $(once('insert-column', searchBlock, context)).after(divCol);

      if($(downloadBlock).length == 0) {
        widthButtons = 'col-md-12';
      }

      if($(changeLocation).length == 0) {
        widthButtons += ' ft-right';
      }

      $('.group-buttons', context).removeClass('col-md-8').addClass(widthButtons);

      $download.removeClass('hidden').addClass('visible-md visible-lg');
      $change.removeClass('hidden');
      $share.removeClass('hidden').addClass('visible-md visible-lg');
      $print.removeClass('hidden').addClass('visible-md visible-lg');

    }
  };

})(jQuery, Drupal, once);
